export enum CatalogSearchCriteriaType {
  Transport = 'transport',
  TransportManagement = 'transportManagement',
  AutomotiveAftermarket = 'automotiveAftermarket',
  AllocationView = 'allocationView',
  Uli = 'uli',
}
